export { SliderSlide, type SliderSlideProps } from "./SliderSlide";
